<template>
  <div>
    <section class="map-section" v-if="polygon != null">
      <l-map
        style="height: 40vh; width: 100%; position: relative"
        :center="mapCenter"
        :zoom="13"
      >
        <l-tile-layer :url="map.url"> </l-tile-layer>
        <l-geo-json :geojson="polygon"> </l-geo-json>
      </l-map>
    </section>
    <section>
      <h4 class="headline">Liens utiles</h4>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title
              >Environnement (établissements scolaires, commerces de proximité,
              montant des taxes, etc)</v-list-tile-title
            >
            <v-list-tile-sub-title
              ><a :href="dataFranceUrl"
                >http://map.datafrance.info</a
              ></v-list-tile-sub-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Description du quartier</v-list-tile-title>
            <v-list-tile-sub-title
              ><a href="http://www.kelquartier.com"
                >http://www.kelquartier.com</a
              ></v-list-tile-sub-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Transports en commun</v-list-tile-title>
            <v-list-tile-sub-title
              ><a href="https://citymapper.com"
                >https://citymapper.com</a
              ></v-list-tile-sub-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Calcul d'itinéraire</v-list-tile-title>
            <v-list-tile-sub-title
              ><a href="https://www.google.fr/maps/"
                >https://www.google.fr/maps/</a
              ></v-list-tile-sub-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>

      <div v-if="iris">
        <h4 class="headline">Données</h4>
        <v-list>
          <HostEnvironmentLine name="Nom du quartier" :value="nom_iris" />
          <HostEnvironmentLine name="Nom de la ville" :value="nom_com" />
          <HostEnvironmentLine name="Nom du département" :value="nom_dept" />
        </v-list>
        <h4 class="headline">Habitations</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="housing in iris.housing"
            :name="housing.title"
            :value="housing.value"
          />
        </v-list>
        <h4 class="headline">Pour faire les courses</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="shop in iris.shop"
            :name="shop.title"
            :value="shop.value"
          />
        </v-list>
        <h4 class="headline">Scolarité</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="school in iris.schools"
            :name="school.title"
            :value="school.value"
          />
        </v-list>
        <h4 class="headline">Se détendre</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="relax in iris.relax"
            :name="relax.title"
            :value="relax.value"
          />
        </v-list>
        <h4 class="headline">Santé</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="health in iris.health"
            :name="health.title"
            :value="health.value"
          />
        </v-list>
        <h4 class="headline">Utilitaire</h4>
        <v-list>
          <HostEnvironmentLine
            v-for="util in iris.utils"
            :name="util.title"
            :value="util.value"
          />
        </v-list>
      </div>
    </section>
  </div>
</template>

<script>
import { EnvironmentService } from "../../iris";
import HostEnvironmentLine from "./HostEnvironmentLine";
import { LMap, LTileLayer, LCircleMarker, LGeoJson } from "vue2-leaflet";
import bbox from "geojson-bbox";

import "leaflet/dist/leaflet.css";
export default {
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    HostEnvironmentLine,
    LGeoJson
  },
  props: ["geoLoc"],
  name: "HostEnvironment",
  data() {
    return {
      nom_iris: null,
      nom_com: null,
      iris: null,
      nom_dept: null,
      polygon: null,
      map: {
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
      },
      mapCenter: []
    };
  },
  async mounted() {
    const env = new EnvironmentService();
    const cb = await env.init(this.geoLoc.coordinates);
    if (cb) {
      const iris = cb.iris[0];
      this.nom_iris = iris.properties.nom_iris;
      this.nom_com = iris.properties.nom_com;
      this.nom_dept = iris.properties.nom_dept;
      const rIris = await env.getIrisMainInfos(iris);
      if (rIris) {
        this.iris = rIris;
      }
      this.polygon = env.getPolygon(iris);
      const bb = bbox(this.polygon);
      this.mapCenter = [bb[1], bb[0]];
    }
  },
  computed: {
    dataFranceUrl() {
      return (
        "http://map.datafrance.info/education?coords.lat=" +
        this.geoLoc.coordinates[1] +
        "&coords.lng=" +
        this.geoLoc.coordinates[0] +
        "&zoom=15&d.d1.id=ecoles-maternelles&d.d1.gr=marker&d.d1.y=2014&d.d1.gp=appellation-officielle-de-l-uai&d.d1.f=secteur&d.d1.on=1&d.d1.slug=d1&d.d2.id=ecoles-elementaires&d.d2.gr=marker&d.d2.y=2014&d.d2.gp=appellation-officielle-de-l-uai&d.d2.f=secteur&d.d2.on=1&d.d2.slug=d2&d.d3.id=colleges&d.d3.gr=marker&d.d3.y=2014&d.d3.gp=appellation-officielle-de-l-uai&d.d3.f=secteur&d.d3.on=1&d.d3.slug=d3&d.d4.id=lycees-legt&d.d4.gr=marker&d.d4.y=2014&d.d4.gp=appellation-officielle-de-l-uai&d.d4.f=secteur&d.d4.on=1&d.d4.slug=d4&d.d5.id=lycees-lp&d.d5.gr=marker&d.d5.y=2014&d.d5.gp=appellation-officielle-de-l-uai&d.d5.f=secteur&d.d5.on=1&d.d5.slug=d5&d.d6.id=enseignement-superieur&d.d6.gr=marker&d.d6.y=2015&d.d6.gp=nom&d.d6.f=statut-etablissement-sup&d.d6.on=1&d.d6.slug=d6&d.d7.id=ecoles-doctorales&d.d7.gr=marker&d.d7.y=2014&d.d7.gp=libelle-de-l-ecole-doctorale-obligatoire&d.d7.on=1&d.d7.slug=d7"
      );
    }
  }
};
</script>

<style scoped>
h4 {
  margin-left: 8px;
  margin-top: 16px;
}
</style>
